// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n.texts-context[data-v-f711f0b6] {\n  font-size: 12px;\n  line-height: 18px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 75px;\n  height: 100%;\n}\n.texts-context span[data-v-f711f0b6] {\n    text-align: center;\n    width: 90px;\n    white-space: nowrap;\n    /* 不换行 */\n    overflow: hidden;\n    /* 超出部分隐藏 */\n    text-overflow: ellipsis;\n    /* 超出部分显示为省略号 */\n}\n", ""]);
// Exports
module.exports = exports;
